import React from 'react';
import { AnimatedCounter } from '../UI/AnimatedCounter';
export const Stats = () => {
  const stats = [{
    value: 7,
    label: 'Cities Active'
  }, {
    value: 180,
    label: 'Community Members'
  }, {
    value: 100,
    label: 'Opportunities Shared',
    suffix: '+'
  }, {
    value: 7,
    label: 'Salons Curated'
  }];
  return <section className="py-16 border-b border-gray-200 bg-secondary/5" data-id="element-551">
      <div className="container mx-auto px-4" data-id="element-552">
        <h2 className="text-3xl font-bold text-center mb-12 text-secondary-dark" data-id="element-553">
          Our Impact
        </h2>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-center" data-id="element-554">
          {stats.map((stat, index) => <div key={index} className="bg-white border border-gray-200 rounded-lg p-6 shadow-sm hover:shadow-md transition-shadow" data-id="element-555">
              <AnimatedCounter end={stat.value} suffix={stat.suffix || ''} className="text-4xl font-bold text-primary" data-id="element-556" />
              <div className="mt-2 text-secondary" data-id="element-557">{stat.label}</div>
            </div>)}
        </div>
      </div>
    </section>;
};